// extracted by mini-css-extract-plugin
export default {"text__area":"specificStyle_text__area__uVUDn","parents__dropdown":"specificStyle_parents__dropdown__YEC5z","text__area__label":"specificStyle_text__area__label__IPPTw"};